<script lang="js">
import Session        from '@/shared/services/session';
import Records        from '@/shared/services/records';
import EventBus       from '@/shared/services/event_bus';
import AbilityService from '@/shared/services/ability_service';
import Flash  from '@/shared/services/flash';

export default {
  props: {
    comment: Object,
    autofocus: Boolean
  },

  data() {
    return {
      actor: Session.user(),
      canSubmit: true,
      processing: false
    };
  },

  computed: {
    placeholder() {
      const parent = this.comment.parent();
      if (!parent) { return this.$t('comment_form.share_your_thoughts'); }
      if (parent.isA('poll')) {
        return this.$t('comment_form.share_on_poll');
      } else
      if (parent.isA('comment')) {
        return this.$t('comment_form.in_reply_to', {name: parent.author().nameOrUsername()});
      } else {
        return this.$t('comment_form.share_your_thoughts');
      }
    },

    maxLength() {
      return this.comment.parent().topic().commentLengthMax || undefined;
    }
  },

  methods: {
    handleIsUploading(val) {
      return this.canSubmit = !val;
    },

    submit() {
      this.processing = true;
      this.comment.save().then(() => {
        const flashMessage = !this.comment.isNew() ?
                        'comment_form.messages.updated'
                      : this.comment.isReply() ?
                        'comment_form.messages.replied'
                      :
                        'comment_form.messages.created';
        Flash.success(flashMessage, {name: this.comment.isReply() ? this.comment.parent().author().nameOrUsername() : undefined});
        setTimeout(() => {
          this.$emit('comment-submitted');
          EventBus.$emit('deleteDraft', 'comment', this.comment.id, 'body');
        });
      }).catch(err => {
        Flash.serverError(err);
      }).finally(() => this.processing = false);
    }
  }
};

</script>

<template lang="pug">
.d-flex.comment-form
  .topic-item__avatar.mr-3
    user-avatar(
      :user='comment.author() || actor'
      :size='comment.parentId ? 28 : 32'
    )
  form.topic-item__body.comment-form__body(v-on:submit.prevent='submit()' v-submit-on-mod-enter="submit")
    lmo-textarea.ml-n1(
      :model='comment'
      @is-uploading="handleIsUploading"
      field="body"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :max-length="maxLength"
    )
      template(v-slot:actions)
        v-btn.comment-form__submit-button(
          variant="elevated"
          :loading="processing"
          :disabled="!canSubmit || comment.saveDisabled"
          color="primary"
          type='submit'
        )
          span(v-t="comment.isNew() ? 'comment_form.post_comment' : 'common.action.save' ")
</template>

<style>
.comment-form__body {
  flex-grow: 1;
}
</style>
